import React from "react";
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Tooltip, useTheme } from "@mui/material";
import { Dashboard, DocumentScanner, EditNote, PlayCircleFilledWhite, Psychology, School } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { permissionTest } from "system/InfegyUser";
import { useStarscapeAcademy } from "hooks/useStarscapeAcademy";

export default function StartPageResources(): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const { openAcademy, errorMessage: academyError, isLoading: academyLoading } = useStarscapeAcademy();

  return (
    <Paper>
      <List>
        <ListItem>
          <ListItemButton component="a" target="_blank" href="https://help.infegy.com/en/articles/9797442-starscape-getting-started-guide">
            <ListItemIcon>
              <PlayCircleFilledWhite  sx={{ fontSize: "2em", color: theme.colors.namedColors.chart1 }}/>
            </ListItemIcon>
            <ListItemText slotProps={{ primary: { variant:"h4" } }} primary={i18n.t("start-page.resources.getting-started")} />
          </ListItemButton>
        </ListItem>
        <Tooltip
          title={academyError || ""}
          placement="left">
          <Box>
            <ListItem>
              <ListItemButton
                disabled={academyLoading}
                onClick={() => { void openAcademy(); }}
                sx={{ opacity: academyLoading ? 0.5 : 1 }}>
                <ListItemIcon>
                  <School sx={{ fontSize: "2em" }} />
                </ListItemIcon>
                <ListItemText slotProps={{ primary: { variant:"h4" } }} primary={i18n.t("nav.academy")} />
              </ListItemButton>
            </ListItem>
          </Box>
        </Tooltip>
        <ListItem>
          <ListItemButton component="a" target="_blank" href="https://help.infegy.com/en/collections/14957353-ai-features">
            <ListItemIcon>
              <Psychology  sx={{ fontSize: "2em", color: theme.colors.namedColors.chart2 }}/>
            </ListItemIcon>
            <ListItemText slotProps={{ primary: { variant:"h4" } }} primary={i18n.t("start-page.resources.gen-ai-features")} />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton component="a" target="_blank" href="https://help.infegy.com/en/collections/14956971-query-building-toolkit">
            <ListItemIcon>
              <EditNote  sx={{ fontSize: "2em", color: theme.colors.namedColors.chart3 }}/>
            </ListItemIcon>
            <ListItemText slotProps={{ primary: { variant:"h4" } }} primary={i18n.t("start-page.resources.query-writing")} />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton component="a" target="_blank" href="https://help.infegy.com/en/collections/14957030-dashboards-knowledge">
            <ListItemIcon>
              <DocumentScanner  sx={{ fontSize: "2em", color: theme.colors.namedColors.chart6 }}/>
            </ListItemIcon>
            <ListItemText slotProps={{ primary: { variant:"h4" } }} primary={i18n.t("start-page.resources.dashboard-types")} />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton component="a" target="_blank" href="https://help.infegy.com/en/collections/14957176-widgets-knowledge">
            <ListItemIcon>
              <Dashboard  sx={{ fontSize: "2em", color: theme.colors.namedColors.chart5 }}/>
            </ListItemIcon>
            <ListItemText slotProps={{ primary: { variant:"h4" } }} primary={i18n.t("start-page.resources.widgets")} />
          </ListItemButton>
        </ListItem>
      </List>
    </Paper>
  );
}